import React from 'react';

const beginsWithSameLetter = (a, b) =>
  a.toUpperCase().charAt(0) === b.toUpperCase().charAt(0);

// This doesn't appear if a company has more than 1,000 users and if bulk edit isn't enabled
const GroupMembershipSelector = ({
  isNewGroup,
  addGroupMember,
  removeGroupMember,
  groupMembers,
  users,
}) => {
  return (
    <>
      <h5>
        {isNewGroup
          ? t('groups.new_membership_new_group')
          : t('groups.new_membership_existing_group')}
        {':'}
      </h5>
      <section className="memberships">
        {users.map((person, idx) => {
          return (
            <React.Fragment key={`member${person.id}`}>
              {idx === 0 ||
              !beginsWithSameLetter(person.name, users[idx - 1].name) ? (
                <h5 className="letter">{person.name.charAt(0)}</h5>
              ) : (
                <h5 className="letter empty">{}</h5>
              )}

              <div className="members">
                <label
                  htmlFor={`member${person.id}`}
                  className="member checkbox"
                >
                  <input
                    type="checkbox"
                    id={`member${person.id}`}
                    checked={groupMembers.some(member => member === person.id)}
                    onChange={({ currentTarget: { checked } }) =>
                      checked
                        ? addGroupMember(person.id)
                        : removeGroupMember(person.id)
                    }
                  />

                  <h5>{person.name}</h5>
                </label>
              </div>
            </React.Fragment>
          );
        })}
      </section>
    </>
  );
};

export default GroupMembershipSelector;
